export const apiUrlCreator = (
	apiUrl: string,
	route: string,
	params?: { [key: string]: string }
) => {
	if (!apiUrl) {
		throw new Error('`apiUrl` param required in function');
	}
	if (!route) {
		throw new Error('`route` param required in function');
	}
	if (route.includes(':') && params === undefined) {
		throw new Error('`params` param required in function');
	}

	// fix possible slash errors on concatenation
	if (apiUrl.charAt(apiUrl.length - 1) === '/') {
		apiUrl = apiUrl.substring(0, apiUrl.length - 1);
	}

	if (route.charAt(0) !== '/') {
		route = '/' + route;
	}

	const routeParamsKeys = route
		.split('/')
		.filter((item) => item.includes(':'))
		.map((item) => item.replace(':', ''));

	const queryParamsString = params
		? Object.keys(params)
				.filter((item) => !routeParamsKeys.includes(item))
				.reduce(
					(accumulator, current) =>
						`${accumulator}${current}=${params[current]}&`,
					'?'
				)
		: '';

	let resultRoute = route;

	for (const paramKey of routeParamsKeys) {
		if (params?.[paramKey] === undefined) {
			throw new Error(
				`missing \`${paramKey}\` param required by route \`${route}\``
			);
		}

		resultRoute = resultRoute.replace(`:${paramKey}`, `${params[paramKey]}`);
	}

	console.log(`Requesting to: ${apiUrl}${resultRoute}${queryParamsString}`);
	return apiUrl + resultRoute + queryParamsString;
};

export const capitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getFixedText = (text: string) => {
	return text
		.toLowerCase()
		.replace(/(^|\s)\S/g, (l) => l.toUpperCase())
		.replace(/\s+/g, ' ')
		.trim();
};

export const getFixedSpaces = (text: string) => {
	return text.replace(/\s+/g, ' ').trim();
};

export const removeTextSpaces = (text: string) => text.replace(' ', '');
